import { GetProceduresRecommendations } from 'domain/usecases/surgical-order-recommendation/get-procedures-recommendations'
import { makeAutoObservable } from 'mobx'

type Services = {
  getProceduresRecommendations: GetProceduresRecommendations
}

export class SurgicalOrderRecommendationService {
  constructor(private readonly services: Services) {
    makeAutoObservable(this)
  }

  async getProceduresRecommendations(
    params: GetProceduresRecommendations.Params
  ): Promise<GetProceduresRecommendations.Model> {
    return this.services.getProceduresRecommendations.get(params)
  }
}

export default SurgicalOrderRecommendationService
